import React, { PureComponent } from 'react';
import moment from 'moment';
import 'moment-timezone';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { Link } from 'react-router-dom';
import PostActions from 'components/FeedList/Post/PostActions';
import GameIcon from 'components/GameIcon';
import ProfileIcon from 'components/ProfileIcon';
import TimeSince from 'components/TimeSince';
import { fromIso9075DateString } from 'utils/dates';
import { GET_GAMES_QUERY } from 'utils/graphql/gamingQueries';
import { isEmbedded } from 'utils/mode';
import { userShape, wallPostShape } from 'utils/shapes';
import WindCreekWImage from 'resources/WindCreekWGray.svg';
import './TournamentStartSoon.css';

class TournamentStartSoon extends PureComponent {
  render() {
    const {
      post,
      user,
      onDeletePost,
      showLegacyFeed,
      gamesData: { games }
    } = this.props;
    const message = JSON.parse(post.message);
    const {
      gameName,
      gameDisplayName,
      name: tournamentName,
      description,
      tournamentId,
      end
    } = message;

    const className = showLegacyFeed
      ? 'legacy-feed-tournament-start-soon'
      : 'feed-tournament-start-soon';
    const game =
      games && games.games && games.games.find(game => game.name === gameName);

    return (
      <div className={className}>
        <div className="feed-message-specifics">
          <ProfileIcon src={WindCreekWImage} size={30} />
          <div className="feed-message-author-container">
            <strong>A Tournament begins in 5 minutes!</strong>
            <div className="post-time">
              <TimeSince
                date={fromIso9075DateString(post.created)}
                prefix="posted"
              />
            </div>
          </div>
        </div>

        <div>
          <div className="tournament-start-soon-container">
            <GameIcon game={game} alt={gameDisplayName} />

            <div className="tournament-start-soon-message">
              <div className="tournament-start-soon-message-header">
                {tournamentName}
              </div>
              <div
                className={`tournament-start-soon-message-description${
                  isEmbedded() ? ' tournament-start-soon-space' : ''
                }`}
              >
                {description}
              </div>

              {!isEmbedded() && (
                <TournamentLinkButton
                  tournamentId={tournamentId}
                  tournamentName={tournamentName}
                  endDateTime={end}
                />
              )}
            </div>
          </div>
        </div>
        <PostActions
          post={post}
          user={user}
          onDeletePost={onDeletePost}
          showLegacyFeed={showLegacyFeed}
        />
      </div>
    );
  }
}

TournamentStartSoon.propTypes = {
  user: userShape,
  post: wallPostShape,
  onDeletePost: PropTypes.func,
  showLegacyFeed: PropTypes.bool
};

function TournamentLinkButton({ tournamentId, tournamentName, endDateTime }) {
  const to = moment().isAfter(moment(endDateTime))
    ? '/tournament/' + tournamentId
    : '/tournament/' + tournamentId;
  return (
    <Link
      to={to}
      className="alert-confirm btn button-color-green  tournament-start-soon-button"
      aria-label={`View upcoming tournament - ${tournamentName}`}
    >
      View Now
    </Link>
  );
}

const withData = graphql(GET_GAMES_QUERY, { name: 'gamesData' });

export default withData(TournamentStartSoon);
